import isSdiraInvestment from "./isSdiraInvestment";
import isEntityInvestment from "./isEntityInvestment";

type Investment = {
  name: string;
  profileType?: string;
  investorAccountId: string;
};

type ComputeAccountFullname = (accountId: string) => string;

const NAME_NOT_DEFINED = "NA";

const computeInvestmentName = (
  computeAccountFullname: ComputeAccountFullname,
  investment: Investment,
): string => {
  const isSdira = isSdiraInvestment(investment);
  const isEntity = isEntityInvestment(investment);

  const { name, investorAccountId } = investment;
  const investorName = computeAccountFullname(investorAccountId);

  const isNotDefined = name === NAME_NOT_DEFINED;

  if (isNotDefined) {
    return investorName;
  }

  const shouldIncludeInvestorName = isSdira || isEntity;

  if (shouldIncludeInvestorName) {
    return `${investorName} - ${name}`;
  }

  return name;
};

export default computeInvestmentName;
